import GetItemsVacina from "../../components/getItemsVacina";
import Header from "../../components/Header";


export default function Vacinas(){
    return(
       <>
         <Header/>
         <GetItemsVacina/>
       </>
    )
}